var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("hr", {
      staticStyle: {
        "flex-basis": "100%",
        height: "0",
        margin: "0",
        border: "0",
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-100 checklist" },
      [
        _c(
          "draggable",
          {
            key: _vm.nonce,
            staticClass: "pl-0",
            attrs: {
              tag: "ul",
              animation: 200,
              "ghost-class": "ghost",
              handle: ".checklist-item-drag-handle",
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.modelItems,
              callback: function ($$v) {
                _vm.modelItems = $$v
              },
              expression: "modelItems",
            },
          },
          [
            _c(
              "transition-group",
              { attrs: { type: "transition", name: "flip-list" } },
              _vm._l(_vm.modelItems, function (item, index) {
                return _c(
                  "li",
                  {
                    key: item.order,
                    staticClass: "d-flex align-items-center checklist-item p-2",
                  },
                  [
                    !_vm.readOnly
                      ? _c(
                          "span",
                          { staticClass: "mr-3 checklist-item-drag-handle" },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(" menu "),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "d-flex justify-content-start w-100" },
                      [
                        _c(
                          "span",
                          {
                            ref: "itemRefs",
                            refInFor: true,
                            staticClass: "checklist-item-text",
                            class: { clickable: !_vm.readOnly },
                            on: {
                              click: function ($event) {
                                return _vm.edit(index)
                              },
                              focusout: function ($event) {
                                return _vm.stopEdit(index)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.stopEdit(index)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.text) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.readOnly
                          ? _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons clickable checklist-delete-item ml-auto",
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(index)
                                  },
                                },
                              },
                              [_vm._v("\n              delete\n            ")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.readOnly
          ? _c("div", { staticClass: "form-group-material" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newItem,
                    expression: "newItem",
                  },
                ],
                staticClass: "material-input checklist-new-item",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("settings.boardsTab.enterItem") + "...",
                },
                domProps: { value: _vm.newItem },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addItem.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newItem = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                [_vm._v(_vm._s(_vm.$t("settings.boardsTab.newItem")))]
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }